import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import CatalogProduct from './product';

class Component extends BaseComponent {
    componentWillMount() {
        this.props.getPrices({
            search: this.props.filters.search,
            price: this.props.filters.price,
        });
    }

    render({ products, filters }) {
        const count = products ? products.length : 0;

        if (products && count) {
            return (
                <catalog-content>
                    { this.renderHeader() }
                    <div class='product-list'>
                        { products.map(product => this.renderProduct(product)) }
                    </div>
                </catalog-content>
            );
        } else if (!products && !filters.length) { //initial page load, no products or filters
            return (
                <catalog-content>
                    { this.renderHeader() }
                    <h2>Retrieving products...</h2>
                </catalog-content>
            );
        }

        // no products with filters,
        return (
            <catalog-content>
                { this.renderHeader() }
                <h2>No results found.</h2>
            </catalog-content>
        );

    }

    renderHeader() {
        return (
            <header>
                <h1>Readings & Reports</h1>
                { this.renderSubheader() }
            </header>
        );
    }

    renderSubheader() {
        if (this.props.user.logged_in) {
            const total_kcs = this.props.user.kcs.total.toLocaleString();
            return (
                <p>
                    { this.props.user.username }, you have <a href='/store/karma-coins'>
                        { total_kcs } KARMA COINS</a> to use towards your purchase.
                    <br />
                    Browse our products below or <a href='/store/karma-coins'>GET MORE KARMA COINS</a>.
                </p>
            );
        }

        return (<p>Choose from our authentic collection of readings and reports to get the insight you need.</p>);
    }

    renderProduct(product) {
        return (
            <CatalogProduct product={product} />
        );
    }
}

const mapStateToProps = (state) => ({
    products: state.catalog && state.catalog.filteredProducts,
    filters: state.catalog && state.catalog.filter,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    getPrices: (payload) => dispatch({ type: 'catalog:get-prices', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/catalog/content.js